import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: number;
  email?: string;
  username?: string;
  name?: string;
  role: 'boss' | 'manager' | 'employee';
  isActive?: boolean;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setUser: (user: User, token: string) => void;
  setUserData: (user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: (user, token) => set({ user, token, isAuthenticated: true }),
      setUserData: (user) => set((state) => ({ ...state, user })),
      logout: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
